import { Show, type JSX } from 'solid-js';
import { ec2StateTone, statusTone, systemStatusTone } from '../lib/format';
import type { BoxStatus } from '../lib/types';
import { Badge } from '../ui/Badge';

/** Workbench lifecycle status: the record in DynamoDB, not the EC2 state. */
export function BoxStatusBadge(props: { status: BoxStatus }): JSX.Element {
  return (
    <Badge tone={statusTone(props.status)} dot pulse={props.status === 'Updating'}>
      {props.status}
    </Badge>
  );
}

/** Live EC2 instance state. Present on the list only when it was fetched with
 *  ec2_status=true, and on the single-box endpoint whenever an instance exists. */
export function Ec2StatusBadge(props: { status: string | null | undefined }): JSX.Element {
  return (
    <Show when={props.status}>
      {(state) => (
        <Badge tone={ec2StateTone(state())}>ec2: {state()}</Badge>
      )}
    </Show>
  );
}

/** EC2 system status check; present under the same conditions as Ec2StatusBadge. */
export function SystemStatusBadge(props: { status: string | null | undefined }): JSX.Element {
  return (
    <Show when={props.status}>
      {(status) => <Badge tone={systemStatusTone(status())}>system: {status()}</Badge>}
    </Show>
  );
}
